// PriceList.js
import React from "react";
import { priceListData } from "../data";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { fadeIn } from "../variants";

const staggerContainer = {
  hidden: {},
  show: { transition: { staggerChildren: 0.15, delayChildren: 0.2 } },
};

// egy szolgáltatás-sor: név ..... ár
const ServiceRow = ({ service }) => (
  <motion.li
    variants={fadeIn("up")}
    className="flex items-baseline gap-2 mb-3 text-sm"
  >
    <span className="font-medium whitespace-nowrap">{service.name}</span>
    <span className="flex-1 border-b border-dotted border-white/30 translate-y-[-3px]"></span>
    <span className="whitespace-nowrap text-white/90">{service.price}</span>
  </motion.li>
);

// egy kategória renderelése (lista vagy alkategóriás objektum)
const CategoryBlock = ({ data }) =>
  Array.isArray(data) ? (
    <ul>
      {data.map((service, i) => (
        <ServiceRow key={i} service={service} />
      ))}
    </ul>
  ) : (
    Object.keys(data).map((sub, i) => (
      <div key={i} className="mb-6">
        <h4 className="font-semibold mb-3 text-left uppercase tracking-wide text-white/80">
          {sub}
        </h4>
        <ul>
          {data[sub].map((service, j) => (
            <ServiceRow key={j} service={service} />
          ))}
        </ul>
      </div>
    ))
  );

const PriceList = () => {
  const { title, services, warning_parent, warning_home } = priceListData;
  const { ref, inView } = useInView();
  const controls = useAnimation();

  React.useEffect(() => {
    if (inView) controls.start("show");
  }, [controls, inView]);

  const cards = [
    { heading: "Babáknak és Gyerekeknek", data: services.Babáknak },
    { heading: "Felnőtteknek", data: services.Felnőtteknek },
  ];

  return (
    <section id="pricelist" className="section bg-dark text-white py-16" ref={ref}>
      <div className="container mx-auto">
        <motion.h2
          className="h2 text-center mb-12 text-white"
          variants={fadeIn("up")}
          initial="hidden"
          animate={controls}
        >
          {title}
        </motion.h2>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          animate={controls}
          className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto"
        >
          {cards.map((card, i) => (
            <motion.div
              key={i}
              variants={fadeIn("up")}
              className="bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-sm"
            >
              <h3 className="font-bold mb-6 text-xl text-center">{card.heading}</h3>
              <CategoryBlock data={card.data} />
            </motion.div>
          ))}
        </motion.div>

        <motion.div variants={fadeIn("up")} className="text-center mt-12">
          <p className="text-lg font-semibold text-red-400">{warning_parent}</p>
          <small className="text-white/70">{warning_home}</small>
        </motion.div>
      </div>
    </section>
  );
};

export default PriceList;